import { timeOffDurationOptions } from 'containers/TimeOff/shared/options';
import yup from 'utils/yup';

export const initialRecordTimeOffFormData = {
  category: '' as any,
  start_date: undefined as undefined | Date,
  end_date: undefined as undefined | Date,
  requested_hours_type: 'Full Day',
  requested_hours: '',
  description: '',
  time_off_duration_options: timeOffDurationOptions,
};

export const recordTimeOffFormValidationSchema = yup.object().shape({
  category: yup.string().required(),
  start_date: yup.date().required().typeError({ msg: 'This must be a valid date' }),
  end_date: yup
    .date()
    .min(yup.ref('start_date'), () => ({
      msg: 'common:minDate',
    }))
    .required()
    .typeError({ msg: 'This must be a valid date' }),
  requested_hours: yup.number().when(['requested_hours_type'], {
    is: (type: string) => type === 'Specific Hours',
    then: yup
      .number()
      .min(0, { msg: "You can't have less than 0 hour per day" })
      .max(24, { msg: "You can't have more than 24 hours per day" })
      .required(),
  }),
  description: yup.string().required(),
});
